import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

function GeneralSelect({ value, onChange, items, name, label }) {

  return (
    <FormControl variant="filled" sx={{ width: '100%' }}>
      <InputLabel id={name + '-label'}>{label}</InputLabel>
      <Select
        labelId={name + '-label'}
        name={name}
        id={name}
        value={value || ""} // Controlled value, default to "" if undefined
        onChange={onChange} // Pass change event to parent
        label={label}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {items.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default GeneralSelect;